import { useNavigate } from 'react-router-dom';

export const useCustomNavigate = () => {
  const navigate = useNavigate();

  const customNavigate = (target) => {
    const hashIndex = target.indexOf('#');
    const pathname = hashIndex === -1 ? target : target.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : target.slice(hashIndex);

    const scrollToHash = () => {
      if (!hash) return;
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
    };

    if (pathname && pathname !== window.location.pathname) {
      navigate(pathname);
      setTimeout(scrollToHash, 0);
    } else {
      scrollToHash();
    }
  };

  return customNavigate;
};
